import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/useinfo/icon-drawer-arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-931e031c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-text-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tab-title" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentList, (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "faq-wrapper"
      }, [
        _createElementVNode("div", {
          class: "item-tab",
          onClick: ($event: any) => (_ctx.openDetail(idx))
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.Title), 1),
          _createElementVNode("img", {
            class: _normalizeClass(["tab-arrow", { 'active-arrow': _ctx.isActive === idx }]),
            src: _imports_0
          }, null, 2)
        ], 8, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass(["content-box", { 'active-box': _ctx.isActive === idx }])
        }, [
          _createElementVNode("p", {
            class: "box-text",
            innerHTML: item.Contents
          }, null, 8, _hoisted_4)
        ], 2)
      ]))
    }), 128))
  ]))
}